var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tag-relation-type-column" },
    [
      _c(
        "TagThird",
        { attrs: { type: _vm.correctedType, size: "extra-small" } },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.tagsHuman[_vm.type].label) + "\n    "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }